import * as yup from 'yup'

import { emailRegex, textRegex, nameRegex } from '@constants/regexes'

export const validationSchema = yup.object().shape({
  name: yup
    .string()
    .typeError('Please check the name')
    .required('Name is a required field')
    .matches(nameRegex, 'Please check your name')
    .max(80, 'Maximum 80 characters'),
  businessDomain: yup
    .string()
    .typeError('Please check your business domain')
    .required('Business domain is a required field')
    .matches(nameRegex, 'Please check your business domain')
    .max(80, 'Maximum 80 characters'),
  overview: yup
    .string()
    .typeError('Please check your text')
    .required('Brief overview is a required field')
    .matches(textRegex, 'Please check your text')
    .max(500, 'Maximum 500 characters'),
  email: yup
    .string()
    .email('Please check your E-mail')
    .required('E-mail is a required field')
    .matches(emailRegex, 'Please check your E-mail'),
})
